import {
  dashboardStatsResponseSchema, type DashboardStatsResponse, type ReportPeriod 
} from '../types';
import {
  ApiClientError, buildUrl 
} from '@/errors';
import { getAuthHeaders } from '@/lib/api-client';

const API_BASE_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:3000';

export interface DashboardStatsParams {
  readonly siteId: string;
  readonly period?: ReportPeriod;
}

export async function getDashboardStats(params: DashboardStatsParams): Promise<DashboardStatsResponse> {
  const searchParams = new URLSearchParams();
  if (params.period) searchParams.set('period', params.period);

  const url = buildUrl(API_BASE_URL, `/v1/sites/${params.siteId}/reports/dashboard`, searchParams);
  const response = await fetch(url, {
    headers: await getAuthHeaders(),
    credentials: 'include',
  });
  
  if (!response.ok) {
    throw ApiClientError.fromResponse(response, 'Failed to fetch dashboard stats');
  }

  return dashboardStatsResponseSchema.parse(await response.json());
}
